import store from '@/store'

export const checkPermission = (value) => {
  // const { value } = binding;
  const permissions = store.getters && store.getters['user/getBtnPerms']
  if (value) {
    let hasPermission = false
    if (value instanceof Array && value.length > 0) {
      const permissionRoles = value
      hasPermission = permissions.some((perm) => {
        return permissionRoles.includes(perm)
      })
    } else if (typeof value === 'string' || typeof value === 'number') {
      hasPermission = permissions.includes(value)
    }
    return hasPermission
  }
  return true
  // throw new Error(`need permissions! Like v-perm="['xxx','yyyy']"`);
}

const bindPermFn = (el, binding) => {
  const { value } = binding
  const hasPermission = checkPermission(value)

  if (!hasPermission) {
    if (el.parentNode) {
      el.parentNode.removeChild(el)
    }
  }
}

const directive = {
  inserted(el, binding) {
    bindPermFn(el, binding)
  },
  update(el, binding) {
    bindPermFn(el, binding)
  },
}

// const install = function (Vue) {
//   Vue.directive('perm', directive);
// };

function install(Vue) {
  Vue.directive('perm', directive)
}

export default install
